import React from 'react';
import {useDispatch} from 'react-redux';
import {I18n} from '@aws-amplify/core';

import RecordForm from '../forms/RecordForm';

import {FormPageLayout} from 'pac-platform-ui-components';

import {saveSigninOption} from '../reducers/recordsSlice';

export const AddPage = () => {
    const dispatch = useDispatch();

    return (
        <FormPageLayout title={I18n.get('Add Sign-in Options')} tools={[]}>
            <RecordForm
                handleSubmit={(values) => dispatch(saveSigninOption(values))}
            />
        </FormPageLayout>
    );
};
